import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import { TextField, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import InsertCommentIcon from '@material-ui/icons/InsertComment';

import './styles.css';
import ItecDialog from '../../../modules/checkListGenerator/itechChecklist/itechAddRelevancePopUp';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    // textField: {
    //     width: '25ch',
    // },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        // marginTop:theme.spacing(1),
        width: '100%',
        color: '#919191',
        fontSize: '15px',
        // padding: '6px 0 12px',
        fontWeight: '300',
        borderBottom: '1px solid #ccc !important',
    },
    heading1: {
        fontSize: '15px',
        fontWeight: 700,
        color: '#000',
    },
    bottomLine: {
        // borderBottom: '1px solid #ccc !important',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
}));

const ItechLabelC = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });
    const [itecOpen, setItecOpen] = React.useState(false);

    const handleRelevence = () => {
        //console.log('handleRele++++');
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };
    return (
        <>
            <Grid container spacing={3} className="main-container">
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Name of company</InputLabel>
                        <Input
                            // disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.name}
                            placeholder="Enter Name"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">PAN of the company</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.pan}
                            placeholder="Enter PAN"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography className={classes.heading1}>Particular</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">No. of shares</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter no. Shares"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Cost of acquisition</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Cost"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography className={classes.heading1}>Shares acquired during the year</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">No. of shares</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter no. Shares"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    {/* <FormControl fullWidth className={classes.margin}> */}
                    <InputLabel htmlFor="standard-adornment-amount">Date of subscription / purchase</InputLabel>
                    {/* <Input
                        className={classes.bottomLine}
                        id="standard-adornment-amount"
                        value={values.value}
                        placeholder="Enter no. Shares"
                        // onChange={handleChange('amount')}
                    /> */}
                    <TextField
                        disabled
                        id="date"
                        // label="Birthday"
                        type="date"
                        placeholder="Pick Date"
                        format="YYYY/MM/DD"
                        InputProps={{ inputProps: { max: '9999-12-31' } }}
                        // defaultValue="2017-05-24"
                        className={clsx(classes.bottomLine, classes.textField)}
                        // className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        className={classes.button}
                        startIcon={<InsertCommentIcon />}
                        onClick={handleRelevence}
                    >
                        Add Relevance
                    </Button>
                    {/* </FormControl> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount"> Face value per share</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Value"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Issue price per share (in case of fresh issue)</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter issue price"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">
                            Purchase price per share (in case of purchase from existing share holder)
                        </InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Purchase price"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography className={classes.heading1}> Shares transferred</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">No. of shares</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter no. Shares"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Sales consideration</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Sale"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <Typography className={classes.heading1}> Closing balance</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">No. of shares</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter no. Shares"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Cost of acquisition</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Sale"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth className={classes.margin} disabled>
                        <InputLabel htmlFor="standard-adornment-amount">Sale consideration</InputLabel>
                        <Input
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.value}
                            placeholder="Enter Sale"
                            // onChange={handleChange('amount')}
                        />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                {/* <Grid item xs={12} sm={12}>
                <div className="plpr12">
                    <Button variant="outlined" color="primary" className={classes.chekListAddBtn} className="txt-capitalize">
                        Add More
                    </Button>
                </div>
            </Grid> */}
            </Grid>
            {itecOpen && <ItecDialog itecOpen={itecOpen} handleItecClose={handleItecClose} />}
        </>
    );
};

export default ItechLabelC;
